module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/channels/call-9add6936cffb49ba6ba1efd697f011c2.svg";